// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Iq-z","breadcrumbForward":"Jq-z","breadcrumbBack":"Kq-z","selected":"Lq-z"};